import React from "react";

export default function DecreaseVector({ color }) {
  return (
    <>
      <svg
        width="153"
        height="56"
        viewBox="0 0 153 56"
        fill="none"
        color={color}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.7731 14.613C19.8115 12.8869 6.44038 21.1512 0 25.4991V56H153V0C145.481 5.72095 129.775 17.1629 127.108 17.1629C123.773 17.1629 119.556 6.66899 115.338 5.00174C111.121 3.33449 108.669 22.1646 104.942 22.1646C101.215 22.1646 90.3288 18.4378 85.2289 17.1629C80.1289 15.8879 73.1654 20.8897 67.6731 22.1646C62.1808 23.4396 59.8269 14.613 55.6096 14.613C51.3923 14.613 38.0538 25.4991 33.8365 25.4991C29.6192 25.4991 24.225 16.7706 21.7731 14.613Z"
          fill="url(#paint0_linear_417_3037)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_417_3037"
            x1="77"
            y1="-68"
            x2="77"
            y2="47"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#F04438" stopOpacity="0" />
            <stop offset="1" stopColor="currentColor" />
          </linearGradient>
        </defs>
      </svg>
    </>
  );
}
